// 激活人数
import request from '@/utils/request';
export function activation(data) {
  return request({
    url: '/data/activity',
    method: 'get',
    params: data
  });
}